import { createTestId } from '../../common/selectors';

export const calendarContainerTestId = createTestId('calendar-container');
export const calendarOfferingIssuerNameSelector = createTestId(`calendar-offering-issuer-name`);
